var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 34,
    viewBox: "0 0 39 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3218 21.4639L25.3082 26.4643L20.3079 31.4646L22.2857 33.4286L29.25 26.4643L22.2857 19.5L20.3218 21.4639Z",
    fill: "#0F2554"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0718 21.4639L35.0582 26.4643L30.0579 31.4646L32.0357 33.4286L39 26.4643L32.0357 19.5L30.0718 21.4639Z",
    fill: "#0F2554"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7143 25.0714H2.78571V4.05321L18.7061 15.0707C18.9392 15.2325 19.2162 15.3191 19.5 15.3191C19.7838 15.3191 20.0608 15.2325 20.2939 15.0707L36.2143 4.05321V16.7143H39V2.78571C39 2.0469 38.7065 1.33834 38.1841 0.815917C37.6617 0.293494 36.9531 0 36.2143 0H2.78571C2.0469 0 1.33834 0.293494 0.815917 0.815917C0.293494 1.33834 0 2.0469 0 2.78571V25.0714C0 25.8102 0.293494 26.5188 0.815917 27.0412C1.33834 27.5637 2.0469 27.8571 2.78571 27.8571H16.7143V25.0714ZM33.15 2.78571L19.5 12.2293L5.85 2.78571H33.15Z",
    fill: "#0F2554"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarta);
export default __webpack_public_path__ + "static/media/carta.1da16dabc147da41b6b8b465c4eaf7e6.svg";
export { ForwardRef as ReactComponent };